// 弹幕类型 - 参考protobuf文件 
// 负数都是前端预留类型
export const MESSAGE_TYPE_ROOM_NOTICE = -99;
export const MESSAGE_TYPE_COMMENT = 0;
export const MESSAGE_TYPE_LIVE_OPEN = 2;
export const MESSAGE_TYPE_LIVE_CLOSE = 3;
export const MESSAGE_TYPE_GIFT = 5;
export const MESSAGE_TYPE_TOP_USERS = 6;
export const MESSAGE_TYPE_ACTION_MSG = 7;
export const MESSAGE_TYPE_COMBO_MSG = 8;
export const MESSAGE_TYPE_MUTE_MSG = 10;
export const MESSAGE_TYPE_WARN_MSG = 11;
export const MESSAGE_TYPE_POPUP_MSG = 12;
export const MESSAGE_TYPE_BLOCK_MSG = 13;
export const MESSAGE_TYPE_ULTIMATE_PRIZE_MSG = 15;
export const MESSAGE_TYPE_RECHARGE_BAR = 16; // 充能条广播

// 弹幕片段类型 - 文字
export const MESSAGE_ITEM_TYPE_TEXT = 1;

// 弹幕片段类型 - 文字 - 子类型
export const MESSAGE_ITEM_SUB_TYPE_COMMENT = 0;
export const MESSAGE_ITEM_SUB_TYPE_NAME = 1;
export const MESSAGE_ITEM_SUB_TYPE_GIFT = 2;
export const MESSAGE_ITEM_SUB_TYPE_GIFTNUM = 3;
export const MESSAGE_ITEM_SUB_TYPE_NEWLINE = 5;

// 弹幕片段类型 - ICON
export const MESSAGE_ITEM_TYPE_ICON = 2;
export const MESSAGE_ITEM_SUB_TYPE_GIFTICON = 4;

// popup 标题位置
export const MESSAGE_ITEM_POPUP_POSITION_TITLE = 1;
// popup 文本位置
export const MESSAGE_ITEM_POPUP_POSITION_CONTENT = 2;

// popup 片段类型 - 文字
export const MESSAGE_ITEM_POPUP_ITEM_TYPE_TEXT = 1;
// popup 片段类型 - ICON
export const MESSAGE_ITEM_POPUP_ITEM_TYPE_ICON = 2;

// export const CONTENT_TYPE_TEXT = 0
// export const CONTENT_TYPE_IMAGE = 1

export const CODE = {
  ok: 0,
  noLogin: -101,
};
